export default __webpack_public_path__ + "static/media/kitchen3-after3-2048w.d4c54e33.png";